import { ATTRIBUTE_DATA_TYPE, EXTERNAL_ATTRIBUTE_ASSET_MATCH_TARGET_TYPE } from './types';

const normalize = (value: string | null | undefined) => (value || '').trim().toLocaleLowerCase();

const hasDuplicate = <T>(items: T[], getKey: (item: T) => string): boolean => {
    const keys = new Set<string>();

    return items.some((item) => {
        const key = getKey(item);
        if (!key) {
            return false;
        }

        if (keys.has(key)) {
            return true;
        }

        keys.add(key);
        return false;
    });
};

const getMatchTargetDataType = (dataType: AttributeDataType): AttributeDataType =>
    dataType === ATTRIBUTE_DATA_TYPE.Link
        ? ATTRIBUTE_DATA_TYPE.String as AttributeDataType
        : dataType;

export function hasInvalidExternalAttributes(
    links: IExternalDataSourceLink[],
    definitions: IExternalAttributeDefinition[],
    matchTargetAttributes: IAttributeDefinition[]
): boolean {
    if (links.some((link) => !normalize(link.DisplayName))) {
        return true;
    }

    if (hasDuplicate(links, (link) => `${link.FacilityID}:${normalize(link.DisplayName)}`)) {
        return true;
    }

    if (definitions.some((definition) => !normalize(definition.Name))) {
        return true;
    }

    if (hasDuplicate(definitions, (definition) => `${definition.ExternalDataSourceLinkID}:${normalize(definition.Name)}`)) {
        return true;
    }

    if (hasDuplicate(definitions, (definition) => `${definition.ExternalDataSourceLinkID}:${normalize(definition.SourceColumnName)}`)) {
        return true;
    }

    return definitions.some((definition) => {
        if (!definition.IsForeignKey) {
            return false;
        }

        const matchTargetDataType = getMatchTargetDataType(definition.DataType);
        if (definition.AssetMatchTargetType === EXTERNAL_ATTRIBUTE_ASSET_MATCH_TARGET_TYPE.AssetName) {
            return matchTargetDataType !== ATTRIBUTE_DATA_TYPE.String;
        }

        return definition.AssetMatchTargetType !== EXTERNAL_ATTRIBUTE_ASSET_MATCH_TARGET_TYPE.AssetAttribute
            || !definition.AssetMatchAttributeDefinitionID
            || !matchTargetAttributes.some((attribute) =>
                attribute.ID === definition.AssetMatchAttributeDefinitionID
                && attribute.DataType === matchTargetDataType);
    });
}
